import React, { useEffect } from 'react'
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { Link, useNavigate, useParams } from 'react-router-dom'
import { get, isEmpty } from "lodash";
import { MdNavigateNext } from 'react-icons/md'
import Swal from "sweetalert2";
import { Button, Container, Grid, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, InputLabel, Badge, ButtonGroup, Checkbox, FormControlLabel, CircularProgress, Dialog } from '@mui/material';
import jwt_decode from "jwt-decode";
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { AiFillCloseCircle } from 'react-icons/ai';
import { useSelector, useDispatch } from 'react-redux'
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { setEditQuestion, stateValues, stateRefresh, setSessionQuestion } from '../../slices/opinionTradingSlice';
import axios from 'axios'
import moment from 'moment'
import Paper from '@mui/material/Paper';
import Skelton from '../../common/Skelton';
import { ACTIVE_ALL_PREDICTION_SALE, CHECK_STATUS, CHECK_TOTAL_TRADES_TRADING, GET_TRADE_YES_AND_NO, JOIN_SLOT_HOLD, MAKE_GST_DATA, MOVE_TO_FINISH_TRADE, SALE_TARDE_ACTIVE, SALE_TARDE_ACTIVE_FIX, TRADE_MANAGE_RATE, TRADING_CANCEL, TRADING_CHANGE_ALL_STATUS, TRADING_CHANGE_STATUS, TRADING_DISTRIBUTE_WINNING, TRADING_FORCE_CANCEL, TRADING_FORCE_CANCEL_ALL, TRADING_HOME_SCREEN, TRADING_LIST, TRADING_WINNING_SET, WINNING_SET_PASSWORD, SOLD_PROFIT_BACK } from '../../constant/endpoint';
import { PREDICTION_TYPE, PREDICTION_TYPE_GST, useStyles } from '../../constant/constant';
import ModalForRate from '../../common/modal';
import FormComponent from '../../components/BotForm';
import { decryptPassword, getNumberBeforeKeyword, setTradeRate } from '../../helper';
import PredictionNvigation from '../../components/PredictionNvigation';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    height: '75%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    padding: '0px 30px',
    overflow: "auto",
    paddingBottom: "20px"
};

const Trading = () => {
    const predictionType ="trading"
    const opinionTradingSlice = useSelector(state => state.opinionTrading)
    const user = useSelector(state => state.loginSlice)
    const userProfile = !isEmpty(user?.token) ? jwt_decode(user?.token) : { accessLevel: 0 }
    console.log("userProfile", userProfile, user);
    const { match_id, series_id, sport } = useParams()
    const [open, setOpen] = React.useState(false);
    const [trading, setTrading] = React.useState([]);
    const [activeSaleAll, setActiveSaleAll] = React.useState(0);
    const [imageofQustion, setImageofQustion] = React.useState(undefined);
    const [value, setValue] = React.useState('1');
    const [tradeCount, setTradeCount] = React.useState({});
    const [sort, setSort] = React.useState({});
    const [Loading, setLoading] = React.useState(true);
    const [apiWork, setApiWork] = React.useState(false)
    const [rateModal, setRateModal] = React.useState(false)
    const [rateData, setRateData] = React.useState({})
    const [showBotModal, setShowBotModal] = React.useState({})
    const [circularLoader, setCircularLoader] = React.useState(false);
    const [sessionDialog, setSessionDialog] = React.useState(false);
    const [joinSlot, setJoinSlot] =  React.useState("")      

    const navigate = useNavigate();
    const classes = useStyles();
    const handleChange = (event, newValue) => {
        setValue(newValue);
        getOpinionTrading();
    };
    const imageFile = (e) => {
        const file = e.target.files[0]
        setImageofQustion(file)
    }
    const handleOpen = () => {
        dispatch(stateRefresh())
        setOpen(true)
        setImageofQustion('')
        setApiWork(false)
        dispatch(stateValues({ name: 'predic_start_time', value: `${moment().format("YYYY-MM-DD")}T${moment().format("HH:mm")}` }))
    };
    const handleClose = () => setOpen(false);
    const dispatch = useDispatch();
    useEffect(() => {
        if (isEmpty(trading) && Loading) {
            getOpinionTrading()
            getJoinSlotHold()
        }
    })

    const getOpinionTrading = async () => {
        setLoading(true)
        const response = await axios.get(TRADING_LIST.replace(':match_id', match_id).replace(':series_id', series_id).replace(':sport', sport))
        setActiveSaleAll( (response?.data?.data && response?.data?.data?.active_all_sale ) || 0 )
        if (response?.data?.status && !isEmpty(response?.data?.data?.result)) {
            setTrading(response.data.data.result)
        }
        setLoading(false)
    }

    const setQuestion = (e) => {
        dispatch(stateValues({ name: e.target.name, value: e.target.value }))
    }

    const selectCorrectAnswer = (e) => {
        const option = opinionTradingSlice.questionStates.option.map(data => data.id === Number(e.target.value) ? { ...data, isCorrect: true } : { ...data, isCorrect: false })
        dispatch(stateValues({ name: 'option', value: option }))
    }

    const editOptions = (event, id) => {
        const option = opinionTradingSlice.questionStates.option.map(data => data.id === Number(id) ? { ...data, option: event.target.value } : { ...data })
        dispatch(stateValues({ name: 'option', value: option }))
    }

    // Alert Function
    const getSweetAlert = (type, topic) => {
        Swal.fire({
            position: 'top-end',
            icon: type,
            title: topic,
            showConfirmButton: false,
            timer: 3000
        })
    }

    const submit = async () => {
        if (IsValidation()) {
            setApiWork(true)
            await submitQuestion()
        }
    }


    const submitQuestion = async () => {
        const formData = new FormData()
      
        let data = {
            ...opinionTradingSlice.questionStates,
            match_id,
            series_id,
            predic_start_time: moment(opinionTradingSlice.questionStates.predic_start_time).utc().format(),
            predic_end_time: moment(opinionTradingSlice.questionStates.predic_end_time).utc().format(),
            sport: sport,
            session_variable: getNumberBeforeKeyword(opinionTradingSlice.questionStates.question_english),
            joinSlotHold: joinSlot
        }
        if(activeSaleAll && !opinionTradingSlice.questionStates.isEdit){
            data["sale_full_amount"] = activeSaleAll   
        }
        formData.append('image', imageofQustion);
        formData.append('data', JSON.stringify(data));
        delete data.status
        let result;
        if (opinionTradingSlice.questionStates.isEdit) {
            result = await axios.patch(TRADING_LIST.replace(':match_id', match_id).replace(':series_id', series_id), formData)
        } else {
            result = await axios.post(TRADING_LIST.replace(':match_id', match_id).replace(':series_id', series_id), formData)

        }

        if (result?.data?.status === 'success') {
            setApiWork(false)
            if (!opinionTradingSlice.isEdit) {
                Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Question Successfully Added',
                    showConfirmButton: false,
                    timer: 1500
                })
            } else {
                Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Question Successfully Edit',
                    showConfirmButton: false,
                    timer: 1500
                })
            }
        }
        getOpinionTrading()
        handleClose()
    }
    const IsValidation = () => {
        let status = true
        const data = opinionTradingSlice.questionStates
        if (isEmpty(data.question_english)) {
            status = false
            getSweetAlert('error', 'Enter the question')
        } else if (data.slots_per_user <= 0) {
            status = false
            getSweetAlert('error', 'Enter Slot Per user')
        } else if (+data.slots_per_user > 1000000) {
            status = false
            getSweetAlert('error', `Slot not more than 200000`)
        }
        else if (isEmpty(data.predic_start_time)) {
            status = false
            getSweetAlert('error', 'Start Time Must Be More Than Present Time')
        }
        else if (data.isSession == true && (!data.question_english.includes("score") || !(/score\s+\d+/i).test(data.question_english))) {
            status = false
            getSweetAlert('error', 'Invalid Session Question')
        }
        else if (isEmpty(data.predic_end_time) || (moment(data.predic_end_time).format("YYYY-MM-DD, HH:mm") < moment(data.predic_start_time).format("YYYY-MM-DD, HH:mm"))) {
            status = false
            getSweetAlert('error', 'End Time Must be Larger Than Start Time')
        } else if (Number(data.admin_commission) < 10) {
            status = false
            getSweetAlert('error', 'Admin Commission Not Less Than 10')
        }
        else if (data?.option.find((op) => (op.option === ""))) {
            status = false
            getSweetAlert('error', 'Please Enter Options')
        }
        else if (data?.partial_refund_value != 1 && data?.partial_refund_value != 0 && data?.partial_refund_value != 0.5){
            status = false
            getSweetAlert('error', 'Please Enter Partial Refund Value 0 , 0.5 or 1 ')
        }
        return status
    }
    const editQuestion = (data) => {
        setImageofQustion('')
        setOpen(true)
        const inPlayData = {
            ...data,
            predic_start_time: `${moment(data.predic_start_time).format(
                "YYYY-MM-DD"
            )}T${moment(data.predic_start_time).format("HH:mm")}`,
            predic_end_time: `${moment(data.predic_end_time).format(
                "YYYY-MM-DD"
            )}T${moment(data.predic_end_time).format("HH:mm")}`,
            isEdit: true,
        };
        dispatch(setEditQuestion(inPlayData));
        getOpinionTrading()
    }
    
    const breadcrumbs = [
        <Link underline="hover" key="1" color="inherit" to={'/matchlist'} >
            <h4>Matchlist</h4>
        </Link>, <Link
            underline="hover"
            color="inherit"
        >
            Prediction
        </Link>, <h5>{'Trading'}</h5>
    ];
    const questionStatus = async (status, _id) => {
        let data;
        if (status) {
            data = { status: 0, match_id, series_id, _id, sport: sport }
        } else {
            data = { status: 1, match_id, series_id, _id, sport: sport }
        }
        await axios.post(TRADING_CHANGE_STATUS, data)
        getOpinionTrading()
    }
      
    const addOnHomeScreen = async (status, _id) => {
        let data;
        if (status) {
            data = { home_screen: false, match_id, series_id, _id, sport: sport }
        } else {
            data = { home_screen: true, match_id, series_id, _id, sport: sport }
        }
        await axios.post(TRADING_HOME_SCREEN.replace(":match_id",match_id).replace(":series_id", series_id), data)
        getOpinionTrading()
    }
    const tradingCancel = async (data, _id) => {
        const statusCheck = await axios.post(CHECK_STATUS, {match_id, sport, tradeId:_id,type:"CANCEL"})
        if (statusCheck && statusCheck.data && statusCheck.data.data == 1) {
            Swal.fire({
                title: 'Error',
                text: "You can not Cancel Twice",
                position: 'top-end',
                timer: 1500,
                showConfirmButton: false 
            })
            return;
        }

        const answer = data.option.filter(x => x.isCorrect)[0].option
        let optionObj = {
            "Select answer": "Select answer"
        };
        for (var obj of data.option) {
            optionObj[obj.option] = obj.option
        }
        Swal.fire({
            title: 'Confirm Your Answer',
            input: 'select',
            inputOptions: optionObj,
            inputAttributes: {
                autocapitalize: 'off'
            },
            showCancelButton: true,
            confirmButtonText: 'Cancel The Match',
            showLoaderOnConfirm: true,

            preConfirm: async (item) => {
                if (item.trim() !== answer.trim()) {
                    getSweetAlert('error', 'Please Correct Answer')
                } else {
                    const bodyData = {
                        prediction_id: _id,
                        type: "cancel",
                        sport:sport
                    }
                    const response = await axios.post(TRADING_CANCEL.replace(':match_id', match_id).replace(':series_id', series_id).replace(':prediction_id', _id), bodyData)
                    if (response && response.data && response.data.status === false) {
                        Swal.fire({
                            position: "top-end",
                            icon: "error",
                            title: response.data.message || "Something Went Wrong",
                            showConfirmButton: false,
                            timer: 1500,
                        });
                    }
                    getOpinionTrading()
                }
            }
        })
    }

    const winningSet = async (match_id, series_id, isCorrectId, data)  => {
        Swal.fire({
            title: 'Wait !',
            text: 'While We are setting the winning',
            imageUrl: 'https://cdn.dribbble.com/users/164889/screenshots/1192618/loading-red-spot.gif',
            imageWidth: 400,
            imageHeight: 200,
            imageAlt: 'Custom image',
            showConfirmButton: false,
            allowOutsideClick: false
        })
        const bodyData = {
            correct_id: isCorrectId,
            admin_commision: data.admin_commission,
            sport: data.sport,
            type: "SET",
            prediction_id:data._id
        }
        const result = await axios.post(

            // /winning_set/trading/match/${match_id}/series/series_id/trade/:trade_id
            TRADING_WINNING_SET.replace(':match_id', match_id).replace(':series_id', series_id).replace(':id', data._id), bodyData
        );
        if (result && result.data && result.data.status === false) {
            Swal.fire({
                position: "top-end",
                icon: "error",
                title: result.data.message || "Something Went Wrong",
                showConfirmButton: false,
                timer: 1500,
            });
        }
        if (result?.data?.status === "success") {
            getOpinionTrading()
            Swal.close()
            Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Winning set successfully",
                showConfirmButton: false,
                timer: 1500,
            });
        }
    }

    const setWinning = async (data) => {
        const statusCheck = await axios.post(CHECK_STATUS, {tradeId:data._id,match_id,sport,type:"SET"})
        if (statusCheck && statusCheck.data && (statusCheck.data.data == 1 || statusCheck.data.data == true)) {
            Swal.fire({
                title: 'Error',
                text: "You can not Set Winning Twice",
                position: 'top-end',
                timer: 1500,
                showConfirmButton: false 
            })
            return;
        }
        const rates = await setRate(data, false)
        const resultCheck = await Swal.fire({
            title: `Do you want Winning Set?`,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        })
        if (resultCheck.isConfirmed) {
            const optionAnser = data.option
            const isCorrectId = (optionAnser.find(data => data.isCorrect)).id
            let isAskPassword = isCorrectId === 1 ? rates[0] > rates[1] ? false : true :  rates[1] > rates[0] ? false : true
            if(isAskPassword){
                const result = await axios.get(WINNING_SET_PASSWORD.replace(':match_id', data.match_id).replace(':prediction_id', data._id))
                if(result.data.status === "success"){
                    Swal.fire({
                        title: `Enter Password For ${data._id}`,
                        input: 'password',
                        preConfirm: (text) => {
                            if(text === decryptPassword(result.data.data)){
                                winningSet(match_id, series_id, isCorrectId, data)   
                            }else {
                                Swal.showValidationMessage('Incorrect password');
                            }
                        }               
                    })
                }
            }else{
                winningSet(match_id, series_id, isCorrectId, data)   
            }
            
        }
    };
    const activeSale = () => {
        Swal.fire({
            title: 'Error',
            text: 'Active the Sale Slot Button',
            position: 'top-right',
            icon: 'error',
            timer: 1500,
            showConfirmButton: false
        })
    }
    const winningDistribution = async (id, isSaleActive, updateData) => {        
        const statusCheck = await axios.post(CHECK_STATUS, {tradeId:id,...updateData, type:"WIN"})
        if (statusCheck && statusCheck.data && (statusCheck.data.data == 1 || statusCheck.data.data == "true")) {
            Swal.fire({
                title: 'Error',
                text: "You can not Distribute Twice",
                position: 'top-end',
                timer: 1500,
                showConfirmButton: false 
            })
            return;
        }
        if(!isSaleActive){
            activeSale()  
            return
        }
        const resultCheck = await Swal.fire({
            title: `Do you want Winning Distribute?`,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        })
        if (resultCheck.isConfirmed) {
            Swal.fire({
                title: 'Wait !',
                text: 'While We are distributing the winning',
                imageUrl: 'https://cdn.dribbble.com/users/164889/screenshots/1192618/loading-red-spot.gif',
                imageWidth: 400,
                imageHeight: 200,
                imageAlt: 'Custom image',
                showConfirmButton: false,
                allowOutsideClick: false
            })
            const bodyData = {
                prediction_id: id,
                type: "distribute"
            }
            const result = await axios.post(
                TRADING_DISTRIBUTE_WINNING.replace(':match_id', match_id).replace(':prediction_id', id).replace('sport_id',sport), bodyData
            );
            if (result && result.data && result.data.status === false) {
                Swal.fire({
                    position: "top-end",
                    icon: "error",
                    title: result.data.message || "Something Went Wrong",
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
            if (result?.data?.status === 'success') {
                getOpinionTrading()
                Swal.close()
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Winning Distribution successfully",
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
        }
    };
    const forceCancelPrediction = async (data) => {
        const statusCheck = await axios.post(CHECK_STATUS, {tradeId:data._id,match_id,sport, type:"FORCE_CANCEL"})
        if (statusCheck && statusCheck.data && (statusCheck.data.data == 1 || statusCheck.data.data == "true")) {
            Swal.fire({
                title: 'Error',
                text: "You can not Force Cancel Twice",
                position: 'top-end',
                timer: 1500,
                showConfirmButton: false 
            })
            return;
        }
        const result = await Swal.fire({
            title: 'Do you want to cancel the prediction ?',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        })
        if (result.isConfirmed) {
            // forceCancel(data._id)   
            const passResult = await axios.get(WINNING_SET_PASSWORD.replace(':match_id', data.match_id).replace(':prediction_id', data._id))
            if(passResult.data.status === "success"){
                Swal.fire({
                    title: `Enter Password For ${data._id}`,
                    input: 'password',
                    preConfirm: (text) => {

                        if(text === decryptPassword( passResult.data.data)){
                            forceCancel(data._id)   
                        }else {
                            Swal.showValidationMessage('Incorrect password');
                        }
                    }               
                })
            }

        
        }
    }
    const duplicateQuestion = async (data) => {
        const result = await Swal.fire({
            title: 'Do you want to duplicate the prediction ?',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        })
        if (result.isConfirmed) {

            const formData = new FormData()
            delete data._id;
            let reqData = {
                ...data,
                match_id,
                series_id,
                predic_start_time: moment(Date.now()).utc().format(),
                predic_end_time: moment(data.predic_end_time).utc().add(2,"minute").format(),
                sport: sport,
                status:0,
                shown_on_mobile: 0,
                isSession: false,
                session_id: null,
                session_variable:null,
                sort_number: 0,
                option: data?.option?.map((opt) => {
                    opt.isCorrect = false;
                    return opt;
                }),
                createdAt: Date.now(),
                updatedAt: Date.now(),
                joined_slot: 0,
                is_prediction_full: false,
                is_pred_cancel: 0,
                is_pred_winset: 0,
                is_slot_cancel: 0,
                is_finish: false,
                winning_amount: 0,
                distribute_winning: false,
                is_for_others:false,
                partial_refund_value: 0,
                book_profit: true,
                home_screen: false,
                trending_question: false,
                is_global_trade:0
            }
            if (activeSaleAll) {
                reqData["sale_full_amount"] = activeSaleAll   
            }
            else {
                reqData["sale_full_amount"] = 0
            }
            // formData.append('image', imageofQustion);
            formData.append('data', JSON.stringify(reqData));
            delete data.status
            let result = await axios.post(TRADING_LIST.replace(':match_id', match_id).replace(':series_id', series_id), formData)
            if (result?.data?.status === 'success') {
                getOpinionTrading()
            }
        
        
        }
    }
    const holdQuestionMatching = async (data) => {
        const tradeData = {
            ...data,
            holdMatching: true,
        };
        dispatch(setEditQuestion(tradeData));
            window.location = `/matchlist/trading/${match_id}/${series_id}/${sport}/${data._id}/hold`
    }
    const addNewSession = async (data) => {
        const result = await Swal.fire({
            title: 'Do you want to add new session ?',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        })
        if (result.isConfirmed) {
            const regex = new RegExp(`(?<=${"score"}\\s+)\\d+`, 'i');
            Swal.fire({
                title: `Enter Session Variable`,
                input: 'text',
                preConfirm: async (sessionVariable) => {
                    if (!sessionVariable) {
                        Swal.showValidationMessage('Please Add Session');
                        return;
                    }
                    const formData = new FormData()
                    delete data._id;                    
                    let reqData = {
                        ...data,
                        match_id,
                        series_id,
                        sport: sport,
                        question_english: data.question_english ? data.question_english.replace(regex, sessionVariable) : "",
                        question_hindi: data.question_hindi ? data.question_hindi.replace(/(\d+)(?=\s*या)/, sessionVariable) : "",
                        status: 0,
                        shown_on_mobile: 0,
                        option: data?.option?.map((opt) => {
                            opt.isCorrect = false;
                            return opt;
                        }),
                        createdAt: Date.now(),
                        updatedAt: Date.now(),
                        joined_slot: 0,
                        is_prediction_full: false,
                        is_pred_cancel: 0,
                        is_pred_winset: 0,
                        is_slot_cancel: 0,
                        is_finish: false,
                        winning_amount: 0,
                        distribute_winning: false,
                        is_for_others: false,
                        session_variable: sessionVariable
                    }
                    if (activeSaleAll) {
                        reqData["sale_full_amount"] = activeSaleAll
                    }
                    else {
                        reqData["sale_full_amount"] = 0
                    }
                    // formData.append('image', imageofQustion);
                    formData.append('data', JSON.stringify(reqData));
                    delete data.status
                    let result = await axios.post(TRADING_LIST.replace(':match_id', match_id).replace(':series_id', series_id), formData)
                    if (result?.data?.status === 'success') {
                        getOpinionTrading()
                    }
        
        
                }
            })
        }
    }
    

    const forceCancel = async (prediction_id) => {
        const bodyData = {
            prediction_id,
            type: "force_cancel",
            match_id,
            sport
        }
        const result = await axios.post(
            TRADING_FORCE_CANCEL.replace(':prediction_id', prediction_id),bodyData
        );
        if (result && result.data && result.data.status === false) {
            Swal.fire({
                position: "top-end",
                icon: "error",
                title: result.data.message || "Something Went Wrong",
                showConfirmButton: false,
                timer: 1500,
            });
        }
        if (result?.data?.status === 'success') {
            getOpinionTrading()
            Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Prediction Cancel successfully",
                showConfirmButton: false,
                timer: 1500,
            });
        }
    }

    const handleShorting = async (data) => {
        let data1 = {
            ...data
        }
        data1.sort_number = sort[data._id]?.sort_number ? sort[data._id]?.sort_number : data.sort_number
        delete data1.status
        const formData = new FormData()
        // formData.append('image', imageofQustion);
        formData.append('data', JSON.stringify(data1));

        let result = await axios.patch(TRADING_LIST.replace(':match_id', match_id).replace(':series_id', series_id), formData)

        if (result?.data?.status === 'success') {
            if (!opinionTradingSlice.questionStates.isEdit) {
                Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Sorting add Successfully',
                    showConfirmButton: false,
                    timer: 1500
                })
            } else {
                Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Sort Add Successfully',
                    showConfirmButton: false,
                    timer: 1500
                })
            }
        }
        getOpinionTrading()
    }
    const handleSortingInput = (e, id) => {
        const value = e.target.value;
        console.log(value.length)
        if (value.length <= 4) {
            setSort(prevValue => ({ ...prevValue, [id]: { sort_number: value } }));
          }
    }
    const checkTotolTrades = async (match_id, sport, id) => {
        const response = await axios.get(CHECK_TOTAL_TRADES_TRADING.replace(':match_id', match_id).replace(':sport', sport).replace(':id', id))
        if (response?.data?.status === 'success') {
            setTradeCount({ data: response.data.data, id: id })
        }
    }
    const RedirectFun = (match_id, series_id, name) => {
        navigate(`/matchlist/${name}/${match_id}/${series_id}?sport=${sport}`)
    }

    const makeGSTData = async (match_id, series_id) => {
        const isValid = await Swal.fire({
            title: 'Do you want to Close the Match ?',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        })
        if (isValid.isConfirmed) {
            setCircularLoader(true)
            const res = await axios.post(MAKE_GST_DATA.replace(':match_id', match_id).replace(':series_id', series_id).replace(':type', PREDICTION_TYPE_GST.TRADING) + `?sport=${sport}`)
            if (res.data.status === "success") {
                getSweetAlert('Success', "Match Closed Successfully")
            }
            setCircularLoader(false)
        }
    }
    const statusActiveFun = async (status) => {
        let data = {
            match_id,
            series_id,
            status: status
        }
        const result = await axios.post(TRADING_CHANGE_ALL_STATUS, data)
        if (result?.data?.status === "success") {
            getSweetAlert('Success', status === 1 ? " All Active Trading Succesfully" : "All InActive Trading Succesfully")
            getOpinionTrading()
        }
    }
    const setRate = async (data, forSet = true) => {
        const response = await axios.get(TRADE_MANAGE_RATE.replace(':match_id', data.match_id).replace(':prediction_id', data._id).replace('sport_id', sport))
        if (response?.data?.status === "success") {
            if(forSet){
                Swal.fire({
                    title: 'Yes / No',
                    text: (response.data.data).join('/'),
                    position: 'center'
                })
            }
            return response.data.data
        }
    }

    const getTradeYesAndNo = async (id) => {
        const number = await Swal.fire({
            title: 'Enter The Count',
            input: 'number'
        })
    //     ${{/*<span>Yes Investment:- ${result?.data?.data?.matchedResult?.investOnYes}</span> |
    // <span>No Investment:- ${result?.data?.data?.matchedResult?.investOnNo}</span> |*/}}
        const result = await axios.get(GET_TRADE_YES_AND_NO.replace(':prediction_id', id).replace(':limit', number.value || 0))
        if (result?.data?.status === "success") {
            Swal.fire({
                position: 'top-end',
                title: `count = ${result?.data?.data?.count}`,
                icon: 'success',
                html: `<div>${result?.data?.data?.result} <hr /> 
               
                <span>YES/NO Rate :- ${result?.data?.data?.matchedResult?.rateRationByLast10Matched?.yes}/${result?.data?.data?.matchedResult?.rateRationByLast10Matched?.no}</span>
                </div>`,
                showConfirmButton: false,
                width: '100%'
            })
        }
    }

    const setBotSlot = (data) => {
        Swal.fire({
            title: 'Provide The Passwords',
            input: 'password',
            showCancelButton: true,
            confirmButtonText: 'Submit',
            showLoaderOnConfirm: true,
            preConfirm: (text) => {
                if (text === 'showForm') {
                    const newData = {
                        _id: data._id,
                        join_rate: data.join_rate,
                        exit_rate: data.exit_rate,
                        join_option_id: data.join_option_id,
                        number_of_slots: data.number_of_slots,
                        join_percentage: data.join_percentage,
                        match_id: data.match_id,
                        series_id: data.series_id,
                    }
                    setShowBotModal(newData)
                }
            }
        })
    }
    const getJoinSlotHold = async () => {
        const response = await axios.get(`${JOIN_SLOT_HOLD}`)
        if (response?.data?.data) {
            setJoinSlot(response.data.data)  
        }
    }

    const hideBotModal = () => {
        setShowBotModal({})
        getOpinionTrading()
    }

    const moveToFinish = async (id, isSaleActive) => {
        if(!isSaleActive){
            activeSale()  
            return
        }
        const isValid = await Swal.fire({
            title: 'Do you want to Finish the Prediction',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        })
        if(isValid.isConfirmed){
            const result = await axios.post(`${MOVE_TO_FINISH_TRADE.replace(':trade_id', id).replace(':match_id', match_id).replace(':series_id', series_id)}`)
            if(result.data.status === "success"){
                Swal.fire({
                    title: 'Success',
                    text: result.data.data,
                    position: 'center'
                })
            }
            getOpinionTrading()
        }
    }

    const saleSlotStatus = async (updateData, id) => {
        const statusCheck = await axios.post(CHECK_STATUS, {tradeId:id,...updateData,type:"SALE"})
        if (statusCheck && statusCheck.data && statusCheck.data.data == 1) {
            Swal.fire({
                title: 'Error',
                text: "You can not Update Sale Twice",
                position: 'top-end',
                timer: 1500,
                showConfirmButton: false 
            })
            return;
        }
        
        const resultCheck = await Swal.fire({
            title: `Do you want Active Sale?`,

            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        })
        if (resultCheck.isConfirmed) {
            Swal.fire({
                title: 'Wait !',
                text: 'While We are setting the sale amount',
                imageUrl: 'https://cdn.dribbble.com/users/164889/screenshots/1192618/loading-red-spot.gif',
                imageWidth: 400,
                imageHeight: 200,
                imageAlt: 'Custom image',
                showConfirmButton: false,
                allowOutsideClick: false
            })
        updateData.value = 1 - (updateData.value ? updateData.value : 0)
           

            updateData["prediction_id"] = id;
            updateData["type"] = "sale";

            const data = await axios.post(SALE_TARDE_ACTIVE.replace(':trade_id', id), updateData)
           
            if (data && data.data && data.data.status === false) {
                Swal.close();
                Swal.fire({
                    position: "top-end",
                    icon: "error",
                    title: data.data.message || "Something Went Wrong",
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
        
            if (data.data.status === "success") {
             Swal.close();
            Swal.fire({
                title: 'Success',
                text: data.data.data,
                position: 'top-end',
                timer: 1500,
                showConfirmButton: false 
            })
            
            getOpinionTrading()
        } 
    }
    }

    const fixSale = async (updateData, id,data) => {
        
        const resultCheck = await Swal.fire({
            title: `Do you want Fix Sale?`,

            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        })
        if (resultCheck.isConfirmed) {
            const passResult = await axios.get(WINNING_SET_PASSWORD.replace(':match_id', data.match_id).replace(':prediction_id', id))
            if (passResult.data.status === "success") {
                Swal.fire({
                    title: `Enter Password For ${id}`,
                    input: 'password',
                    preConfirm: async(text) => {

                        if (text === decryptPassword(passResult.data.data)) {
                            Swal.fire({
                                title: 'Wait !',
                                text: 'While We are setting the sale amount',
                                imageUrl: 'https://cdn.dribbble.com/users/164889/screenshots/1192618/loading-red-spot.gif',
                                imageWidth: 400,
                                imageHeight: 200,
                                imageAlt: 'Custom image',
                                showConfirmButton: false,
                                allowOutsideClick: false
                            })
                            updateData.value = 1 - (updateData.value ? updateData.value : 0)
                       
            
                            updateData["prediction_id"] = id;
                            updateData["type"] = "sale";
            
                            const data = await axios.post(SALE_TARDE_ACTIVE_FIX.replace(':trade_id', id), updateData)
                       
                            if (data && data.data && data.data.status === false) {
                                Swal.close();
                                Swal.fire({
                                    position: "top-end",
                                    icon: "error",
                                    title: data.data.message || "Something Went Wrong",
                                    showConfirmButton: false,
                                    timer: 1500,
                                });
                            }
                    
                            if (data.data.status === "success") {
                                Swal.close();
                                Swal.fire({
                                    title: 'Success',
                                    text: data.data.data,
                                    position: 'top-end',
                                    timer: 1500,
                                    showConfirmButton: false
                                })
                        
                                getOpinionTrading()
                            }

                        } else {
                            Swal.showValidationMessage('Incorrect password');
                        }
                    }
                })
            
            
            }
        }
    }

    const activeSaleForAllQuestion = async () => {
        const resultCheck = await Swal.fire({
            title: `Do you want to change Status?`,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        })
        if (resultCheck.isConfirmed) {
            Swal.fire({
                title: 'Wait !',
                text: 'While We are Active Sale for all questions ',
                imageUrl: 'https://cdn.dribbble.com/users/164889/screenshots/1192618/loading-red-spot.gif',
                imageWidth: 400,
                imageHeight: 200,
                imageAlt: 'Custom image',
                showConfirmButton: false,
                allowOutsideClick: false
            })
            const result = await axios.post(ACTIVE_ALL_PREDICTION_SALE.replace(':match_id', match_id).replace(':sport', sport))
            if (result.data.status === "success") {
                Swal.close()
                Swal.fire({
                    title: 'Success',
                    text: result.data.data,
                    position: 'top-end',
                    timer: 1500,
                    showConfirmButton: false
                })
                getOpinionTrading()
            }
        }
    }

    const forceCancelAll = async () => {
        setCircularLoader(true)
        const result = await axios.post(
            TRADING_FORCE_CANCEL_ALL.replace(':match_id', match_id).replace(":series_id",series_id)
        );
        setCircularLoader(false)
        if (result?.data?.status === 'success') {
         Swal.fire({
                position: "top-end",
                icon: "success",
                title: "All Predictions Cancel successfully",
                showConfirmButton: false,
                timer: 1500,
         });
          await  getOpinionTrading()   
          

        }
    }
    const forceCancelAllPredictions = async () => {
        const result = await Swal.fire({
            title: 'Do you want to cancel all the predictions ?',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        })
        if (result.isConfirmed) {

            const passResult = await axios.get(WINNING_SET_PASSWORD.replace(':match_id', match_id).replace(':prediction_id',series_id)+ "?forceCancel=true")
            if(passResult.data.status === "success"){
                Swal.fire({
                    title: `Enter Password `,
                    input: 'password',
                    preConfirm:async (text) => {
                        if(text === decryptPassword(passResult.data.data)){
                            forceCancelAll()   
                            // await getOpinionTrading()

                        }else {
                            Swal.showValidationMessage('Incorrect password');
                        }
                    }               
                })
            }

        
        }
    }

    const cancelSoldProfit = async (data) =>{
        const resultCheck = await Swal.fire({
            title: `Do you want to Cancel Sold Profit?`,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        })

        if (resultCheck.isConfirmed) {

                const result = await axios.get(WINNING_SET_PASSWORD.replace(':match_id', data.match_id).replace(':prediction_id', data._id))
                if(result.data.status === "success"){
                    Swal.fire({
                        title: `Enter Password For ${data._id}`,
                        input: 'password',
                        preConfirm: (text) => {
                            if(text === decryptPassword(result.data.data)){
                                cancelProfit(data.match_id, sport, data._id)  
                            }else {
                                Swal.showValidationMessage('Incorrect password');
                            }
                        }               
                    })
                }      
        }
}

const cancelProfit = async (match_id, sport, id)  => {
    Swal.fire({
        title: 'Wait !',
        text: 'While We are Cancelling Sale Profit',
        imageUrl: 'https://cdn.dribbble.com/users/164889/screenshots/1192618/loading-red-spot.gif',
        imageWidth: 400,
        imageHeight: 200,
        imageAlt: 'Custom image',
        showConfirmButton: false,
        allowOutsideClick: false
    })
    const bodyData = {
        tradeId: id,
        match_id:match_id,
        sport: sport,
        prediction_id:id
    }
    const result = await axios.post(
        SOLD_PROFIT_BACK, bodyData
    );
    if (result && result.data && result.data.status === false) {
        Swal.fire({
            position: "top-end",
            icon: "error",
            title: result.data.message || "Something Went Wrong",
            showConfirmButton: false,
            timer: 1500,
        });
    }
    if (result?.data?.status === "success") {
        getOpinionTrading()
        Swal.close()
        Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Winning set successfully",
            showConfirmButton: false,
            timer: 1500,
        });
    }
}



    return (
        <>        
  
        {!isEmpty(showBotModal) ? <FormComponent data={showBotModal} hideBotModal={hideBotModal} /> : ''}
            <div className="homeCard">
                <div className='subHomeCard'>
                <div >
                    <Breadcrumbs
                        separator={<MdNavigateNext fontSize="small" />}
                        aria-label="breadcrumb"
                    >
                        {breadcrumbs}
                    </Breadcrumbs>
                    <div>
                        <Container maxWidth="xl">
                            <Grid container style={{ display: "flex", justifyContent: "space-between", paddingBottom: "20px"}}>
                                <Grid item spacing={3} >
                                    <Stack className="subHomeCardHeader" spacing={{ xs: 1, sm: 2 }} direction="row" useFlexGap flexWrap="wrap" mt={2}>
                                        <Button variant={'contained'} color="primary"  onClick={() => handleOpen()}>Add Question</Button>
                                    </Stack>
                                </Grid>
                                <Grid item>
                                    <Grid container style={{ display: "flex", justifyContent: "flex-end", paddingBottom: "20px", }}>
                                        <Grid item spacing={3}>
                                            <Stack spacing={{ xs: 1, sm: 2 }} direction="row" useFlexGap flexWrap="wrap" mt={2}>
                                                <Button variant={'contained'} color='warning' style={{ color: "black", marginRight: "10px" }} onClick={() => makeGSTData(match_id, series_id)}>Match Closed</Button>
                                            </Stack>
                                        </Grid>
                                        <PredictionNvigation  match_id={match_id} series_id={series_id} sport={sport} type={predictionType} refetch={getOpinionTrading} /> 
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container style={{ display: "flex", justifyContent: "flex-end", paddingBottom: "20px", borderBottom: "1px solid #ccc" }}>
                                <Grid item>
                                    <Grid container style={{ display: "flex", justifyContent: "flex-end", paddingBottom: "20px", }}>
                                        <Grid item spacing={3}>
                                            <Stack spacing={{ xs: 1, sm: 2 }} direction="row" useFlexGap flexWrap="wrap" mt={2}>
                                                <Button variant={'contained'} disabled={activeSaleAll ? true : false} color='error' style={{ color: activeSaleAll ? "#000" : "#fff", marginRight: "10px" }} onClick={activeSaleForAllQuestion}>Sale {activeSaleAll ?  "ACTIVE" : "INACTIVE"}</Button>
                                            </Stack>
                                            </Grid>

                                            <Grid item spacing={3}>
                                            <Stack spacing={{ xs: 1, sm: 2 }} direction="row" useFlexGap flexWrap="wrap" mt={2}>
                                                <Button disabled={(trading.filter((trade=>{return trade.status == 1}))).length} variant={'contained'}  color='warning'  onClick={forceCancelAllPredictions}>Force Cancel All</Button>
                                                </Stack>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Container>
                        </div>
                    </div>
                  
                        <Box sx={{ width: '100%', typography: 'body1' }}>
                            <TabContext value={value}>
                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                    <TabList onChange={handleChange} aria-label="lab API tabs example">
                                        <Tab label="LIVE" value="1" />
                                        <Tab label="RESULT" value="2" />
                                    </TabList>
                                </Box>
                                <TabPanel style={{ padding: "0px" }} value="1">
                                    <TableContainer component={Paper} style={{ margin: "30px 0px" }}>
                                        <Table className={classes.table} width="100%" aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Id</TableCell>
                                                    <TableCell align="left" >Question</TableCell>
                                                    <TableCell align="center">End Time</TableCell>
                                                    <TableCell align="center">Sorting</TableCell>
                                                    <TableCell align="center">Answer</TableCell>
                                                    <TableCell align="center">Rate</TableCell>
                                                    <TableCell align="center">Edit</TableCell>
                                                    {/* <TableCell align="center">Slots Join</TableCell> */}
                                                    <TableCell align="center">Status</TableCell>
                                                    <TableCell align="center">Cancel</TableCell>
                                                    <TableCell align="center">Active Sale</TableCell>
                                                    <TableCell align="center">Set</TableCell>
                                                    {userProfile.accessLevel >= 60 && <TableCell align="center">check</TableCell>}
                                                    <TableCell align="center">Force Cancel</TableCell>
                                                    <TableCell align="center">Duplicate Question</TableCell>
                                                <TableCell align="center">New Session</TableCell>
                                                {/* <TableCell align="center">Cancel Sale Profit</TableCell> */}
                                                {/* <TableCell align="center">Hold</TableCell> */}
                                                    {/* <TableCell align="center">Home Screen</TableCell> */}

                                                    {/* <TableCell align="center">Finish</TableCell> */}
                                                </TableRow>
                                        </TableHead>
                                        {circularLoader ?
                                          <div  style={{ position: "absolute", left:"50%" }}>  <CircularProgress ></CircularProgress></div>
                                            :
                                            <TableBody>
                                                {trading?.filter((data) => !(data.is_finish) && !(data.is_processing)).length > 0 ? trading?.filter((data) => !(data.is_finish) && !(data.is_processing))?.map((data, index) => (
                                                    <TableRow style={{ background: data.shown_on_mobile ? "#e1f2e18a" : "white" }}
                                                        key={data.name}
                                                    >
                                                        <TableCell component="th" scope="row">
                                                            {index + 1}
                                                        </TableCell>
                                                        <TableCell style={{ width: 300 }}>{data.question_english} <hr /> {data.question_hindi}</TableCell>
                                                        <TableCell width={100} align="center">
                                                            {moment(data.predic_end_time).format("HH:mm")} <br></br>
                                                            {moment(data.predic_end_time).format("YYYY-MM-DD")}
                                                        </TableCell>

                                                        <TableCell align="left" style={{ display: "flex", background: '#ecffe2', width: "100px" }}>
                                                            <Grid container style={{ display: "flex", background: '#fff' }}>
                                                                <TextField type='number' width={'50px'} size='small' id="outlined-basic" label="Sorting" variant="outlined" style={{ fontStyle: "8px" }} onChange={(e) => handleSortingInput(e, data._id)} autocomplete="off" value={sort[data._id]?.sort_number ? sort[data._id]?.sort_number : data.sort_number} />
                                                                <Button variant='contained' color={'warning'} style={{ fontSize: "11px", width: "60px", padding: '1px' }} onClick={() => handleShorting(data)}>Update</Button>
                                                            </Grid>
                                                        </TableCell>
                                                        <TableCell align='center'>
                                                            <p>{data?.option?.filter(x => x.isCorrect)[0]?.option}</p>
                                                        </TableCell>
                                                        {/* {userProfile.accessLevel >= 100 &&<TableCell align='center'>
                                                        {
                                                            data._id === tradeCount?.id ? <h3>{tradeCount?.data}</h3> : ''
                                                        }
                                                        <Button variant={'contained'} size={'small'} color={'success'} style={{ fontSize: "11px", width: "60px", padding: '1px' }} onClick={() => checkTotolTrades(data.match_id, data.sport, data._id)}>Check</Button>
                                                    </TableCell>} */}
                                                        <TableCell align='center'>
                                                            <Button variant={'contained'} size={'small'} color={'secondary'} onClick={() => setRate(data)}>Get</Button>
                                                            <Button variant={'contained'} sx={{ mt: 1 }} size={'small'} color={'secondary'} onClick={() => setTradeRate(data._id, data.match_id, data.interval, data.sport)}>Set</Button>
                                                        </TableCell>
                                                        <TableCell align='center'><Button variant={'contained'} size={'small'} color={'warning'} onClick={() => editQuestion(data)}>Edit</Button></TableCell>
                
                                                        {/* <TableCell align='center'><Button variant={'contained'} size={'small'} color={'info'} onClick={() => setBotSlot(data)}>Set</Button></TableCell> */}
                                                        <TableCell align='center'>
                                                            <Button variant={'contained'} size={'small'} color={data.status ? 'success' : 'error'} onClick={() => questionStatus(data.status, data._id)}>{data.status ? 'Active' : 'InActive'}</Button>
                                                        </TableCell>
                                                        <TableCell align='center'>
                                                            {
                                                                Number(data.status) === 0 && data?.option.some(x => x.isCorrect) &&
                                                                <Button variant={'contained'} size={'small'} color={'error'} onClick={() => tradingCancel(data, data._id)} >Cancel</Button>
                                                            }
                                                        </TableCell>
                                                        <TableCell align='center'>
                                                            <Button variant={'contained'} size={'small'} color={data.sale_full_amount ? 'success' : 'error'} disabled={data.sale_full_amount || data.status} onClick={() => saleSlotStatus({ value: data.sale_full_amount, match_id, sport }, data._id)}>{data.sale_full_amount ? 'Active' : 'InActive'}</Button>
                                                            {userProfile.accessLevel >= 100 ? <Button variant={'contained'} style={{marginTop:"5px"}} size={'small'} onClick={() => fixSale({ value: data.sale_full_amount, match_id, sport }, data._id, data)}>Fix</Button> : ""}

                                                        </TableCell>
                                                        <TableCell align='center'>
                                                            {
                                                                data.is_slot_cancel === 1 ? <Button variant={'contained'} size={'small'} color={'success'} onClick={() => setWinning(data)}>Set</Button> : ''
                                                            }
                                                            {
                                                                data.is_pred_winset === 1 ? <Button style={{ margin: "5px 10px" }} variant={'contained'} size={'small'} color={'success'} onClick={() => winningDistribution(data._id, data.sale_full_amount, {match_id, sport })}>Distribute</Button> : ''
                                                            }
                                                        </TableCell>
                                                        {userProfile.accessLevel >= 60 && <TableCell><Button variant={'contained'} size={'small'} color='info' onClick={() => getTradeYesAndNo(data._id)}>Check</Button></TableCell>}
                                                        <TableCell> <Button variant={'contained'} size={'small'} color={'error'} onClick={() => forceCancelPrediction(data)} disabled={data.status || !data.shown_on_mobile}>Force Cancel</Button> </TableCell>
                                                        <TableCell> <Button variant={'contained'} size={'small'} color={'warning'} onClick={() => duplicateQuestion(data)} >Duplicate</Button> </TableCell>
                                                        <TableCell> <Button variant={'contained'} size={'small'} color={'primary'} onClick={() => addNewSession(data)} disabled={!data.isSession} >Session</Button> </TableCell>

                                                        {/* <TableCell align='center'>
                                                            <Button variant={'contained'} size={'small'}  disabled={!data.sale_full_amount || data.status ||  data.is_sold_amount_back} onClick={() => cancelSoldProfit(data)}>Cancel Sale Profit</Button>
                                                        </TableCell> */}
                                                        {/* <TableCell> <Button variant={'contained'} size={'small'} color={'warning'} onClick={() => holdQuestionMatching(data)} >Hold</Button> </TableCell> */}
                                                        {/* <TableCell align='center'>
                                                        <Button variant={'contained'} size={'small'} color={data.home_screen ? 'success' : 'error'} onClick={() => addOnHomeScreen(data.home_screen, data._id)}>{data.home_screen ? 'Remove' : 'Add'}</Button>
                                                    </TableCell> */}

                                                        {/* <TableCell>
                                                            {data.status !== 1 && data.is_pred_winset !== 1 && userProfile?.accessLevel
                                                            > 90 ? <Button variant={'contained'} size={'small'} color={'secondary'} onClick={() => moveToFinish(data._id,  data.sale_full_amount)}>Finish</Button> : ''}
                                                    </TableCell> */}
                                                    </TableRow>
                                                )) : Loading ?
                                                <Box sx={{
                                                    position: 'fixed',
                                                    top: 0,
                                                    left: '50%',
                                                    transform: 'translateX(-50%)',
                                                    zIndex: 9999, // Ensure it stays above other elements
                                                    paddingTop: '30%', // Space from top of the page
                                                }}>
                                                    <CircularProgress></CircularProgress>
                                                </Box> 
                                                 : <TableRow><TableCell colSpan={16} style={{ textAlign: "center", padding: "10px" }}><h3>Data Not Found</h3></TableCell>
                                                </TableRow>}
                                            </TableBody>
                                        }
                                        </Table>
                                    </TableContainer>
                                </TabPanel>
                                <TabPanel style={{ padding: "0px" }} value="2">
                                    <TableContainer component={Paper} style={{ margin: "30px 0px" }}>
                                        <Table className={classes.table} sx={{ minWidth: 650 }} aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Id</TableCell>
                                                    <TableCell align="left">Question</TableCell>
                                                    <TableCell align="center">End Time</TableCell>
                                                    <TableCell align="center">View</TableCell>
                                                    {userProfile.accessLevel >= 60 && <TableCell align="center">View Total Trades</TableCell>}
                                                    <TableCell align="center">Cancel</TableCell>
                                                    <TableCell align="center">Rate</TableCell>
                                                    <TableCell align="center">Set</TableCell>
                                                    {userProfile.accessLevel >= 60 && <TableCell align="center">Check</TableCell>}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {trading?.filter((data) => data.is_finish).length > 0 ? trading?.filter((data) => data.is_finish)?.map((data, index) => (
                                                    <TableRow
                                                        key={data.name}
                                                    >
                                                        <TableCell component="th" scope="row">
                                                            {index + 1}
                                                        </TableCell>
                                                        <TableCell>{data.question_english} <hr /> {data.question_hindi}</TableCell>
                                                        <TableCell align="center">{moment(data.predic_end_time).format("HH:mm")} {moment(data.predic_end_time).format("YYYY-MM-DD")}</TableCell>
                                                        <TableCell align='center'><Button variant={'contained'} size={'small'} color={'warning'} onClick={() => editQuestion(data)} >View</Button></TableCell>
                                                        {userProfile.accessLevel >= 60 && <TableCell align='center'>
                                                            {
                                                                data._id === tradeCount?.id ? <h3>{(tradeCount?.data) / 2}</h3> : ''
                                                            }
                                                            <Button variant={'contained'} size={'small'} color={'success'} style={{ fontSize: "11px", width: "60px", padding: '1px' }} onClick={() => checkTotolTrades(data.match_id, data.sport, data._id)}>Check</Button>
                                                        </TableCell>}
                                                        <TableCell align='center'>
                                                            <Button variant={'contained'} size={'small'} color={'error'} onClick={() => tradingCancel(data._id)} disabled >Cancel</Button>
                                                        </TableCell>
                                                        <TableCell align='center'>
                                                            <Button variant={'contained'} size={'small'} color={'secondary'} onClick={() => setRate(data)}>Get</Button>
                                                        </TableCell>
                                                        <TableCell align='center'>
                                                            {
                                                                data.is_slot_cancel === 1 ? <Button variant={'contained'} size={'small'} color={'success'} onClick={() => setWinning(data)} disabled>Set</Button> : ''
                                                            }
                                                            {
                                                                data.is_pred_winset === 1 ? <Button style={{ margin: "5px 10px" }} variant={'contained'} size={'small'} color={'success'} onClick={() => winningDistribution(data._id)} disabled>Distribute</Button> : ''
                                                            }
                                                        </TableCell>
                                                        {userProfile.accessLevel >= 60 && <TableCell><Button variant={'contained'} size={'small'} color='info' onClick={() => getTradeYesAndNo(data._id)}>Check</Button></TableCell>}
                                                    </TableRow>
                                                )) : Loading ? 
                                                <Box sx={{
                                                    position: 'fixed',
                                                    top: 0,
                                                    left: '50%',
                                                    transform: 'translateX(-50%)',
                                                    zIndex: 9999, // Ensure it stays above other elements
                                                    paddingTop: '30%', // Space from top of the page
                                                }}>
                                                    <CircularProgress></CircularProgress>
                                                </Box> 
                                                 : <TableRow><TableCell colSpan={16} style={{ textAlign: "center", padding: "10px" }}><h3>Data Not Found</h3></TableCell></TableRow>}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </TabPanel>
                            </TabContext>
                        </Box>
                    
                </div>

            </div>

            <Modal
                open={open}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                onBackdropClick={() => setOpen(true)}
            >
                <Box sx={style} spacing={0.5} direction="row" useFlexGap flexWrap="wrap">
                    <Grid container>
                        <Grid xs={11}>
                            <h2 id="modal-title" mb={1}>{'Trading'}  Questions</h2>
                        </Grid>
                        <Grid xs={1}>
                            <Button onClick={handleClose}><AiFillCloseCircle style={{ width: "25px", height: "40px" }} /></Button>
                        </Grid>
                        <h4> {opinionTradingSlice.questionStates._id && 'Pred id-'}  {opinionTradingSlice?.questionStates?._id}</h4>
                    </Grid>
                    <hr />
                    <Grid container spacing={1}>
                        <Grid xs={4} item>
                            <label>Slots Per User</label>
                            <TextField id="outlined-basic" type='number' size={'small'} variant="outlined" name={'slots_per_user'} onChange={setQuestion} value={opinionTradingSlice.questionStates.slots_per_user} />
                        </Grid>
                        <Grid xs={6} item>
                            <label>Admin Per Commission</label>
                            <TextField id="outlined-basic" type='number' size={'small'} variant="outlined" name={'admin_commission'} onChange={setQuestion} value={opinionTradingSlice.questionStates.admin_commission} />
                        </Grid>

                       <Grid xs={3} item>
                            <label>Slot Count</label>
                            <TextField id="outlined-basic" type='number' size={'small'} variant="outlined" name={'slot_count'} onChange={setQuestion} value={opinionTradingSlice.questionStates.slot_count} />
                        </Grid>
                       <Grid xs={5} item>
                            <label>Partial Refund Value</label>
                            <TextField id="outlined-basic" type='number' size={'small'} variant="outlined" name={'partial_refund_value'} onChange={setQuestion} value={opinionTradingSlice.questionStates.partial_refund_value} />
                        </Grid>
                        <Grid xs={4} item>
                        <>
                                <label>Type</label>
                                                    <Select id="demo-simple-select-label" style={{ width:"100%",height:"40px"}} type='select' name={"question_type"} value={opinionTradingSlice.questionStates.question_type}  onChange={setQuestion}>
                                                        {PREDICTION_TYPE.map((data, index) =>
                                                            <MenuItem value={data} key={index}>{data}</MenuItem>
                                                        )}
                                                    </Select>
                        </>
                        </Grid>
                        <Grid container ml={1} mt={1}>
                            <Grid xs={6} item>
                                <label>Start Date and Time</label>
                                <TextField type='datetime-local' id="outlined-basic" size={'small'} variant="outlined" name={'predic_start_time'} value={opinionTradingSlice.questionStates.predic_start_time} onChange={setQuestion} disabled={opinionTradingSlice.isEdit === true ? true : false} />
                            </Grid>
                            <Grid xs={6} item>
                                <label>End Date and Time</label>
                                <TextField type='datetime-local' id="outlined-basic" size={'small'} variant="outlined" name={'predic_end_time'} value={opinionTradingSlice.questionStates.predic_end_time} onChange={setQuestion} disabled={get(opinionTradingSlice, "questionStates.is_finish")} />
                            </Grid>
                        </Grid>
                        <Grid xs={12} item mt={1}>
                            <label>Interval</label>
                            <br></br>
                            <ButtonGroup style={{ marginTop: "20px" }} disabled={opinionTradingSlice.questionStates.isEdit}>
                                <Button
                                    aria-label="reduce"
                                    onClick={() => {
                                        dispatch(stateValues({ name: 'interval', value: Math.max(+opinionTradingSlice.questionStates.interval - 0.5, 0.5) }))
                                    }}
                                >
                                    <strong>-</strong>
                                </Button>
                                <Badge color="secondary" badgeContent={opinionTradingSlice.questionStates.interval}>
                                </Badge>
                                <Button
                                    style={{ marginRight: "30px" }}
                                    aria-label="increase"
                                    onClick={() => {
                                        dispatch(stateValues({ name: 'interval', value: Math.min(+opinionTradingSlice.questionStates.interval + 0.5, 1) }))
                                    }}
                                >
                                    <strong>+</strong>
                                </Button>
                            </ButtonGroup>
                            <FormControlLabel control={<Checkbox onChange={(e) => dispatch(stateValues({ name: 'is_global_trade', value: !opinionTradingSlice?.questionStates?.is_global_trade }))} name={'is_global_trade'} defaultChecked={opinionTradingSlice?.questionStates?.is_global_trade} value={opinionTradingSlice?.questionStates?.is_global_trade} />} label="Global Trade" />
                            <FormControlLabel control={<Checkbox onChange={(e) => dispatch(stateValues({ name: 'book_profit', value: !opinionTradingSlice?.questionStates?.book_profit }))} name={'book_profit'} defaultChecked={opinionTradingSlice?.questionStates?.book_profit} value={opinionTradingSlice?.questionStates?.book_profit} />} label="Book Profit" />
                            <FormControlLabel control={<Checkbox onChange={(e) => dispatch(stateValues({ name: 'home_screen', value: !opinionTradingSlice?.questionStates?.home_screen }))} name={'home_screen'} defaultChecked={opinionTradingSlice?.questionStates?.home_screen} value={opinionTradingSlice?.questionStates?.home_screen} />} label="Home Screen" />
                            <FormControlLabel control={<Checkbox onChange={(e) => dispatch(stateValues({ name: 'trending_question', value: !opinionTradingSlice?.questionStates?.trending_question }))} name={'trending_question'} defaultChecked={opinionTradingSlice?.questionStates?.trending_question} value={opinionTradingSlice?.questionStates?.trending_question} />} label="Trending Question" />
                            <FormControlLabel control={<Checkbox onChange={(e) => dispatch(stateValues({ name: 'isSession', value: !opinionTradingSlice?.questionStates?.isSession }))} name={'isSession'} defaultChecked={opinionTradingSlice?.questionStates?.isSession} value={opinionTradingSlice?.questionStates?.isSession} />} label="Session" disabled={opinionTradingSlice?.questionStates?.isSession ? true : false} />


                            {/* <Button variant={'contained'} size={'small'} color={data.home_screen ? 'success' : 'error'} onClick={() => addOnHomeScreen(data.home_screen, data._id)}>{data.home_screen ? 'Remove' : 'Add'}</Button> */}

                            {/* <FormControlLabel control={<Checkbox onChange={(e) => dispatch(stateValues({ name: 'is_for_others', value: !opinionTradingSlice?.questionStates?.is_for_others }))} name={'is_for_others'} defaultChecked={opinionTradingSlice?.questionStates?.is_for_others} value={opinionTradingSlice?.questionStates?.is_for_others} />} label="For Others" /> */}
                        </Grid>
                        <Grid xs={12} item mt={1}>
                            <label>Write Question in English</label>
                            <TextField fullWidth id="standard-basic" size={'small'} placeholder="Write Question in English" name={'question_english'} value={opinionTradingSlice.questionStates.question_english} variant="outlined" onChange={setQuestion} disabled={get(opinionTradingSlice, "questionStates.is_finish") || get(opinionTradingSlice, "questionStates.status") === 1} />
                        </Grid>
                        <Grid xs={12} item mt={1}>
                            <label>Write Question in Hindi</label>
                            <TextField fullWidth id="standard-basic" size={'small'} placeholder="Write Question in Hindi" name={'question_hindi'} value={opinionTradingSlice.questionStates.question_hindi} variant="outlined" onChange={setQuestion} disabled={get(opinionTradingSlice, "questionStates.is_finish") || get(opinionTradingSlice, "questionStates.status") === 1} />
                        </Grid>
                        <Grid xs={12} item mt={1}>
                            <label>Session Variable</label>
                            <TextField fullWidth id="standard-basic" size={'small'} placeholder="Session Variable" name={'session_variable'} value={opinionTradingSlice.questionStates.session_variable} variant="outlined" onChange={setQuestion} disabled={get(opinionTradingSlice, "questionStates.is_finish") || get(opinionTradingSlice, "questionStates.status") === 1} />
                        </Grid>
                        {
                            <Grid xs={12} mt={1} item>
                                <label>Options</label>
                                {opinionTradingSlice?.questionStates?.option?.length ? opinionTradingSlice?.questionStates?.option.map((data) => (
                                    <TextField style={{ marginBottom: '10px' }} fullWidth value={data?.option} size={'small'} disabled={opinionTradingSlice.questionStates.isEdit || get(opinionTradingSlice, "questionStates.is_finish") || get(opinionTradingSlice, "questionStates.status") === 1} onChange={(event) => editOptions(event, data.id)}></TextField>
                                )) : ""}
                            </Grid>
                        }
                        {
                            <>
                                {opinionTradingSlice.questionStates.isEdit &&
                                    <Grid item container>
                                        <FormControl variant="outlined" size={'small'} sx={{ m: 1, minWidth: '100%' }}>
                                            {!isEmpty(opinionTradingSlice.questionStates.option) &&
                                                <>
                                                    <InputLabel id="demo-simple-select-label">Please Select Answer</InputLabel>
                                                    <Select id="demo-simple-select-label" style={{ margin: '10px' }} type='select' value={get(get(opinionTradingSlice, 'questionStates.option', []).find(data => data.isCorrect), 'id', '')} disabled={get(opinionTradingSlice, "questionStates.status") || opinionTradingSlice.questionStates.is_slot_cancel === 1 || opinionTradingSlice.questionStates.is_finish ? true : false} onChange={selectCorrectAnswer}>
                                                        {get(opinionTradingSlice, 'questionStates.option', []).map((data, index) =>
                                                            <MenuItem value={data.id} key={index}>{data?.option}</MenuItem>
                                                        )}
                                                    </Select>
                                                </>
                                            }
                                        </FormControl>
                                    </Grid>
                                }
                                <Grid xs={12}>
                                    <input
                                        accept="image/*"
                                        id="contained-button-file"
                                        multiple
                                        type="file"
                                        onChange={imageFile}
                                    />
                                </Grid>
                                <Grid xs={9} mt={2}>
                                    <Button color='error' onClick={handleClose} variant="contained">Cancel</Button>
                                </Grid>
                                <Grid xs={3} mt={2} textAlign={'right'}>
                                    <Button onClick={submit} variant="contained" disabled={apiWork}>Submit</Button>
                                </Grid>
                            </>
                        }
                    </Grid>
                </Box>
            </Modal>
            {
                rateModal && <ModalForRate rateModal={setRateModal} data={rateData} />
            }


<Modal
                open={sessionDialog}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                onBackdropClick={() => setSessionDialog(false)}
            >
                <Box sx={style} spacing={0.5} direction="row" useFlexGap flexWrap="wrap">
                    <Grid container>
                        <Grid xs={11}>
                            <h2 id="modal-title" mb={1}>{'Trading'}  Questions</h2>
                        </Grid>
                        <Grid xs={1}>
                            <Button onClick={()=>setSessionDialog(false)}><AiFillCloseCircle style={{ width: "25px", height: "40px" }} /></Button>
                        </Grid>
                        <h4> {opinionTradingSlice.questionStates._id && 'Pred id-'}  {opinionTradingSlice?.questionStates?._id}</h4>
                    </Grid>
                    <hr />
                    <Grid container spacing={1}>
                        


                        <Grid xs={12} item mt={1}>
                            <label>Interval</label>
                            <br></br>
                            <ButtonGroup style={{ marginTop: "20px" }} disabled={true}>
                                <Button
                                    aria-label="reduce"
                                    onClick={() => {
                                        dispatch(stateValues({ name: 'interval', value: Math.max(+opinionTradingSlice.questionStates.interval - 0.5, 0.5) }))
                                    }}
                                >
                                    <strong>-</strong>
                                </Button>
                                <Badge color="secondary" badgeContent={opinionTradingSlice.questionStates.interval}>
                                </Badge>
                                <Button
                                    style={{ marginRight: "30px" }}
                                    aria-label="increase"
                                    onClick={() => {
                                        dispatch(stateValues({ name: 'interval', value: Math.min(+opinionTradingSlice.questionStates.interval + 0.5, 1) }))
                                    }}
                                    disabled={true}
                                >
                                    <strong>+</strong>
                                </Button>
                            </ButtonGroup>
                         

                                                </Grid>
                        <Grid xs={12} item mt={1}>
                            <label>Write Question in English</label>
                            <TextField fullWidth id="standard-basic" size={'small'} placeholder="Write Question in English" name={'question_english'} value={opinionTradingSlice.questionStates.question_english} variant="outlined" onChange={setQuestion}  />
                        </Grid>
                        <Grid xs={12} item mt={1}>
                            <label>Write Question in Hindi</label>
                            <TextField fullWidth id="standard-basic" size={'small'} placeholder="Write Question in Hindi" name={'question_hindi'} value={opinionTradingSlice.questionStates.question_hindi} variant="outlined" onChange={setQuestion}  />
                        </Grid>
                       
                        {
                            <>
                                <Grid xs={9} mt={2}>
                                    <Button color='error' onClick={handleClose} variant="contained">Cancel</Button>
                                </Grid>
                                <Grid xs={3} mt={2} textAlign={'right'}>
                                    <Button onClick={submit} variant="contained" disabled={apiWork}>Submit</Button>
                                </Grid>
                            </>
                        }
                    </Grid>
                </Box>
     </Modal>   
        </>
    )
}



export default Trading
